// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tab_wrapper_3arHe"};